import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  FeaturedOfferStore,
} from '../../mobx-store/stores/featuredOfferStore';

interface IProps extends WithSnackbarProps {
  featuredOfferStore: FeaturedOfferStore;
  history: any;
}

@inject('featuredOfferStore')
@observer
class FeaturedOffer extends Component<IProps, {
    tableData: any[];
    addButton: any;
  }> {
  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('FeaturedOfferPageTitle');
    this.state = {
      tableData: [],
      addButton: [],
    };
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/deglawy/featuredOffer/${this.props.featuredOfferStore.featuredOffersList[index].featuredOfferId}/edit`);
  };

  handleTableUpButtonCellClicked = async (index: number, key: string) => {
    this.props.featuredOfferStore.swapTwoOfferOrder(index, index - 1)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 8000, 'success');
        this.setState({
          tableData: this.getFeaturedOfferTableData(),
          addButton: this.getAddAdButton(),
        });
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 8000, 'error');
      });
  };

  handleTableDwonButtonCellClicked = async (index: number, key: string) => {
    this.props.featuredOfferStore.swapTwoOfferOrder(index, index + 1)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 8000, 'success');
        this.setState({
          tableData: this.getFeaturedOfferTableData(),
          addButton: this.getAddAdButton(),
        });
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 8000, 'error');
      });
  };

  handelAdd = (): void => {
    this.props.history.push('/deglawy/featuredOffer/new');
  };

  getAddAdButton = () => {
    return {
      title: translate('FeaturedOfferListAddButton'),
      onAdd: this.handelAdd,
      disabled: (this.props.featuredOfferStore.featuredOffersList.length >= 5),
    };
  };

  getFeaturedOfferTableHeader = () => [
    {
      title: translate('FeaturedOfferListImageColumnTitle'),
    },
    {
      title: translate('FeaturedOfferListTitleColumnTitle'),
    },
    {
      title: translate('FeaturedOfferListHotDealColumnTitle'),
    },
    {
      title: translate('FeaturedOfferListOrderColumnTitle'),
    },
    {
      title: translate('FeaturedOfferListEditColumnTitle'),
    },
  ];

  getFeaturedOfferTableData = () => this.props.featuredOfferStore.featuredOffersList
    .map((featuredOffer) => ({
      ...featuredOffer, isHotDeal: featuredOffer.isHotDeal ? 'True' : 'False', edit: 'Edit',
    }));

  getFeaturedOffersTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Image',
      key: 'imageURL',
    },
    {
      cellType: 'Text',
      key: 'title',
    },{
      cellType: 'Text',
      key: 'isHotDeal',
    },
    {
      cellType: 'OrderButtons',
      key: 'order',
      upButtonText: 'Up',
      downButtonText: 'Down',
      onUpButtonClick: this.handleTableUpButtonCellClicked,
      onDownButtonClick: this.handleTableDwonButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('galleryListNoImageMessage')}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.state.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.state.addButton}
          loading={this.props.featuredOfferStore.loading}
        />
      </div>
    );
  }

  async componentDidMount() {
    this.tableHeader = this.getFeaturedOfferTableHeader();
    this.tableCellTypes = this.getFeaturedOffersTableCellTypes();
    await this.props.featuredOfferStore.getFeaturedOffers();
    this.setState({
      tableData: this.getFeaturedOfferTableData(),
      addButton: this.getAddAdButton(),
    });
  }
}

export default FeaturedOffer;
